module.exports = __webpack_public_path__ + "static/img/advert_1.d9c5011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SharePrinting/advert_1.png
// module id = S11l
// module chunks = 10